export default __webpack_public_path__ + "static/media/3.5e80a5e4.jpg";